import { render, staticRenderFns } from "./sotrySlideModal.vue?vue&type=template&id=05e037ea"
import script from "./sotrySlideModal.vue?vue&type=script&lang=js"
export * from "./sotrySlideModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports